var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b62cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3003,
    stopColor: "#985dcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6716,
    stopColor: "#8f4ec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#833ac1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 175.333,
    x2: 134.283,
    xlinkHref: "#lg1",
    y1: 246.14,
    y2: 290.729
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff819c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    stopColor: "#ff7e9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4757,
    stopColor: "#fe7396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6765,
    stopColor: "#fc628e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8668,
    stopColor: "#fa4a83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f83479"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.221,
    x2: 125.372,
    xlinkHref: "#lg2",
    y1: 342.201,
    y2: 401.652
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.805,
    x2: 134.586,
    xlinkHref: "#lg2",
    y1: 158.123,
    y2: 212.266
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.031,
    x2: 375.266,
    xlinkHref: "#lg1",
    y1: 196.796,
    y2: 229.127
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.109,
    x2: 366.461,
    xlinkHref: "#lg1",
    y1: 68.794,
    y2: 100.643
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 391.898,
    x2: 368.805,
    xlinkHref: "#lg3",
    y1: 266.449,
    y2: 309.557
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.549,
    x2: 371.377,
    xlinkHref: "#lg3",
    y1: 126.613,
    y2: 169.357
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 .002 -.002 1 97.656 149.7)",
    gradientUnits: "userSpaceOnUse",
    x1: -67.168,
    x2: -18.955,
    xlinkHref: "#lg3",
    y1: -77.766,
    y2: -13.482
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(1 .002 -.002 1 97.656 149.7)",
    gradientUnits: "userSpaceOnUse",
    x1: 352.432,
    x2: 400.645,
    xlinkHref: "#lg3",
    y1: 194.405,
    y2: 258.689
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(1 .002 -.002 1 97.656 149.7)",
    gradientUnits: "userSpaceOnUse",
    x1: 13.291,
    x2: 45.145,
    xlinkHref: "#lg4",
    y1: -105.568,
    y2: -63.097
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(1 .002 -.002 1 97.656 149.7)",
    gradientUnits: "userSpaceOnUse",
    x1: 14.003,
    x2: 45.857,
    xlinkHref: "#lg3",
    y1: 289.914,
    y2: 332.385
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3ced"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(1 .002 -.002 1 97.656 149.7)",
    gradientUnits: "userSpaceOnUse",
    x1: -31.879,
    x2: -0.026,
    xlinkHref: "#lg5",
    y1: 53.399,
    y2: 95.87
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(1 .002 -.002 1 97.656 149.7)",
    gradientUnits: "userSpaceOnUse",
    x1: 350.602,
    x2: 382.456,
    xlinkHref: "#lg4",
    y1: 100.782,
    y2: 143.253
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(0 -1 1 0 281.282 2818.225)",
    gradientUnits: "userSpaceOnUse",
    x1: 2728.59,
    x2: 2773.233,
    xlinkHref: "#lg6",
    y1: -84.665,
    y2: -125.471
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.756,
    x2: 271.173,
    xlinkHref: "#lg6",
    y1: 358.42,
    y2: 321.476
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 461.814,
    x2: 502.231,
    xlinkHref: "#lg6",
    y1: 135.222,
    y2: 98.278
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(0 -1 1 0 -30.201 2697.713)",
    gradientUnits: "userSpaceOnUse",
    x1: 2275.647,
    x2: 2326.829,
    xlinkHref: "#lg6",
    y1: 89.59,
    y2: 42.806
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 300.747,
    x2: 359.164,
    xlinkHref: "#lg5",
    y1: 327.268,
    y2: 498.733
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3ced",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f43bb"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 373.697,
    x2: 322.492,
    xlinkHref: "#lg7",
    y1: 378.368,
    y2: 371.517
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.818,
    x2: 325.432,
    xlinkHref: "#lg7",
    y1: 421.709,
    y2: 408.727
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.655,
    x2: 303.481,
    xlinkHref: "#lg4",
    y1: 96.05,
    y2: 233.493
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.714,
    x2: 278.271,
    xlinkHref: "#lg8",
    y1: 176.061,
    y2: 179.579
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.763,
    x2: 311.024,
    xlinkHref: "#lg8",
    y1: 141.813,
    y2: 151.585
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m195.909 297.503-59.04 28.538c-21.274 10.283-45.979-5.215-45.979-28.844v-25.458c0-10.151 5.807-19.407 14.946-23.825l59.04-28.538c21.274-10.283 45.979 5.215 45.979 28.844v25.458c0 10.151-5.807 19.408-14.946 23.825z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.805 440.574-75.122-48.202c-21.059-13.513-33.793-36.814-33.793-61.835v-58.798c0 8.796 4.477 16.988 11.88 21.739l74.292 47.669c21.059 13.513 33.793 36.814 33.793 61.835v31.553c0 5.674-6.274 9.103-11.05 6.039z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.94 102.904 75.122 48.202c21.059 13.513 33.793 36.814 33.793 61.835v58.798c0-8.796-4.477-16.988-11.88-21.739l-74.292-47.669c-21.059-13.513-33.793-36.814-33.793-61.835v-31.553c0-5.674 6.275-9.103 11.05-6.039z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m419.95 234.039-42.809 20.693c-15.425 7.456-33.339-3.782-33.339-20.914v-18.46c0-7.36 4.21-14.072 10.837-17.275l42.809-20.693c15.425-7.456 33.339 3.782 33.339 20.914v18.46c.001 7.36-4.21 14.072-10.837 17.275z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.447 109.362-16.306 7.882c-15.425 7.456-33.339-3.782-33.339-20.914v-18.46c0-7.36 4.21-14.072 10.837-17.275l68.416-33.07c3.578-1.729 7.733.877 7.733 4.851v17.463c0 25.36-14.508 48.486-37.341 59.523z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.776 337.779-54.47-34.951c-15.27-9.798-24.503-26.693-24.503-44.836v-42.634c0 6.378 3.246 12.318 8.614 15.763l53.868 34.565c15.27 9.798 24.503 26.693 24.503 44.836v22.878c0 4.114-4.55 6.6-8.012 4.379z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m406.285 128.197-53.868-34.565c-5.368-3.444-8.614-9.384-8.614-15.762v19.832 22.802.077c0 18.143 9.234 35.038 24.503 44.836l53.868 34.565c5.368 3.445 8.614 9.384 8.614 15.763v-19.832-22.803-.077c0-18.143-9.234-35.038-24.503-44.836z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m88.34 96.467c-15.283 9.959-28.323 23.078-38.198 38.424-2.221 3.451-7.346 3.441-9.554-.017-9.819-15.382-22.81-28.548-38.057-38.563-3.384-2.223-3.375-7.278.017-9.488 15.283-9.959 28.322-23.078 38.197-38.424 2.22-3.451 7.345-3.442 9.554.017 9.819 15.382 22.811 28.548 38.057 38.563 3.386 2.222 3.377 7.277-.016 9.488z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.45 369.393c-15.283 9.96-28.323 23.078-38.198 38.424-2.221 3.451-7.346 3.441-9.554-.018-9.819-15.382-22.81-28.547-38.057-38.563-3.384-2.223-3.375-7.278.017-9.488 15.283-9.96 28.322-23.078 38.197-38.424 2.22-3.451 7.345-3.442 9.553.017 9.819 15.382 22.811 28.548 38.057 38.563 3.387 2.224 3.377 7.278-.015 9.489z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.267 60.444c-10.097 6.58-18.712 15.247-25.236 25.386-1.467 2.28-4.853 2.274-6.312-.012-6.487-10.163-15.07-18.861-25.143-25.477-2.236-1.469-2.23-4.808.011-6.269 10.097-6.58 18.712-15.247 25.236-25.386 1.467-2.28 4.853-2.274 6.312.011 6.487 10.163 15.071 18.861 25.144 25.478 2.235 1.469 2.229 4.809-.012 6.269z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.267 455.927c-10.097 6.58-18.712 15.247-25.236 25.386-1.467 2.28-4.853 2.274-6.312-.012-6.487-10.163-15.07-18.861-25.143-25.477-2.236-1.469-2.23-4.808.011-6.269 10.097-6.58 18.712-15.247 25.236-25.386 1.467-2.28 4.853-2.274 6.312.011 6.487 10.163 15.071 18.861 25.144 25.478 2.235 1.469 2.229 4.809-.012 6.269z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.81 219.329c-10.097 6.58-18.712 15.247-25.236 25.386-1.467 2.28-4.853 2.274-6.312-.012-6.487-10.163-15.07-18.861-25.143-25.477-2.236-1.469-2.23-4.808.011-6.269 10.097-6.58 18.712-15.247 25.236-25.386 1.467-2.28 4.853-2.274 6.312.011 6.487 10.163 15.071 18.861 25.144 25.478 2.235 1.469 2.229 4.809-.012 6.269z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.206 267.401c-10.097 6.58-18.712 15.247-25.236 25.386-1.467 2.28-4.853 2.274-6.312-.012-6.487-10.163-15.07-18.861-25.143-25.477-2.236-1.469-2.23-4.808.011-6.269 10.097-6.58 18.712-15.247 25.236-25.386 1.467-2.28 4.853-2.274 6.312.011 6.487 10.163 15.071 18.861 25.144 25.478 2.236 1.469 2.23 4.808-.012 6.269z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.572 116.246h25.055c4.477 0 8.436-2.797 10.05-6.973 4.738-12.256 14.428-22.064 26.604-26.962 4.094-1.647 6.811-5.573 6.811-9.987v-25.154c0-7.037-6.673-12.228-13.464-10.383-31.937 8.677-57.08 34.024-65.462 66.08-1.771 6.773 3.406 13.379 10.406 13.379z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m206.663 321.26v22.683c0 4.053 2.533 7.637 6.313 9.099 11.096 4.29 19.975 13.062 24.41 24.086 1.491 3.707 5.046 6.166 9.041 6.166h22.773c6.371 0 11.071-6.041 9.4-12.189-7.855-28.915-30.804-51.677-59.826-59.266-6.13-1.603-12.111 3.083-12.111 9.421z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m437.721 98.062v22.683c0 4.053 2.533 7.637 6.313 9.099 11.096 4.29 19.975 13.062 24.41 24.086 1.491 3.707 5.046 6.166 9.041 6.166h22.773c6.371 0 11.071-6.041 9.4-12.189-7.855-28.915-30.804-51.677-59.826-59.266-6.13-1.603-12.111 3.083-12.111 9.421z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.332 452.576h28.725c5.133 0 9.672-3.207 11.522-7.995 5.433-14.052 16.541-25.296 30.502-30.913 4.694-1.889 7.809-6.39 7.809-11.45v-28.84c0-8.068-7.651-14.019-15.436-11.904-36.617 9.948-65.442 39.009-75.053 75.762-2.03 7.766 3.905 15.34 11.931 15.34z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m364.075 483.02c-7.953.001-15.942-1.421-23.59-4.312-19.935-7.537-35.022-24.111-40.694-44.571l-38.409 26.226c-2.948 2.013-6.97 1.255-8.983-1.693l-20.161-29.527c-2.013-2.948-1.255-6.97 1.693-8.983l61.428-41.943c2.388-22.435 9.736-44.289 21.733-63.765 1.358-2.205 4.28-2.843 6.441-1.416l32.985 21.776c2.062 1.361 2.657 4.099 1.386 6.218-1.344 2.241-2.598 4.526-3.762 6.85 21.32-2.273 43.273 5.521 58.333 22.459l1.452 1.632c12.674 14.253 18.648 33.285 16.395 52.218-2.252 18.933-12.526 36.03-28.186 46.908-11.333 7.871-24.641 11.922-38.061 11.923zm-20.43-78.828c.472 4.917 1.299 9.818 2.489 14.663l.43 1.749c2.042 8.315 8.467 11.559 11.135 12.567 2.67 1.009 9.633 2.827 16.664-2.057 5.795-4.026 7.26-9.672 7.618-12.679.358-3.008.258-8.841-4.431-14.114l-1.452-1.632c-6.516-7.329-17.535-8.685-25.629-3.158z",
    fill: "url(#SVGID_18_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.926 371.97-1.452-1.632c-15.061-16.937-37.013-24.732-58.333-22.459-15.008 21.547-10.496 56.314-10.496 56.314l6.825-4.66c8.094-5.527 19.113-4.171 25.629 3.158l1.336 1.502h52.22c-2.191-11.855-7.558-23.034-15.729-32.223z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m233.93 420.159c-2.948 2.013-3.706 6.035-1.693 8.983l20.161 29.527c2.013 2.948 6.035 3.706 8.983 1.693l38.409-26.226c-7.697-29.043-4.432-55.92-4.432-55.92z",
    fill: "url(#SVGID_20_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m309.261 131.191c-4.538-16.405-16.64-29.691-32.611-35.73-6.133-2.31-12.535-3.459-18.914-3.459-10.753 0-21.424 3.248-30.5 9.557-12.559 8.724-20.791 22.432-22.596 37.606-.856 7.224-.223 14.47 1.782 21.307.164.586.352 1.161.539 1.736.188.563.387 1.137.586 1.7.821 2.263 1.806 4.468 2.955 6.613.551 1.067 1.161 2.123 1.806 3.154.317.516.645 1.02.973 1.524l.012.012c.328.481.657.95.985 1.419.141.188.27.375.41.563.61.833 1.243 1.63 1.9 2.427.387.469.786.938 1.196 1.395l1.161 1.313c12.066 13.579 29.667 19.817 46.753 18-.926 1.864-1.935 3.694-3.014 5.488-1.02 1.7-.539 3.893 1.114 4.984l26.431 17.46c1.735 1.138 4.081.633 5.171-1.137 9.616-15.608 15.502-33.127 17.414-51.115l19.942-13.613c2.527-1.725 4.039-4.587 4.039-7.647v-34.822c0-3.197-3.581-5.089-6.222-3.286zm-61.164 25.2-1.067-1.196-.094-.105c-3.752-4.233-3.835-8.9-3.553-11.316.293-2.404 1.466-6.93 6.109-10.167 5.64-3.905 11.21-2.451 13.356-1.642 2.134.809 7.294 3.4 8.924 10.073l.34 1.396c.962 3.893 1.618 7.821 2.005 11.761l-5.476 3.729c-6.485 4.433-15.315 3.342-20.544-2.533z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m217.779 181.019 1.163 1.308c12.072 13.576 29.668 19.824 46.757 18.002 12.03-17.271 8.413-45.138 8.413-45.138l-5.47 3.735c-6.488 4.43-15.32 3.344-20.543-2.531l-1.071-1.204h-41.857c1.757 9.502 6.059 18.463 12.608 25.828z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.794 119.927v34.822c0 3.06-1.512 5.922-4.039 7.647l-19.942 13.613s2.615-21.541-3.553-44.818l21.312-14.55c2.641-1.802 6.222.089 6.222 3.286z",
    fill: "url(#SVGID_23_)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.fa917ef29b860f4d9f6357b077454ac3.svg";
export { ForwardRef as ReactComponent };